class Chart

  constructor: (container, options) ->
    @$chart = $(container)
    @echart = echarts.init(@$chart[0], null, {renderer: 'svg'})
    @options = Object.assign({}, @constructor.DEFAULTS, options)
    @echart.setOption(@options)

  @DEFAULTS:
    legend:
      show: false
    toolbox:
      show: false
    tooltip:
      backgroundColor: '#000'
      padding: [8, 12]
      extraCssText: 'border-radius: 3px;'
      textStyle:
        fontSize: 12
        lineHeight: 18

  destroy: ->
    @echart.dispose()
    @$chart.html('')


tower.chart = (container, options) ->
  chart = new Chart(container, options)
  container.data('chart', chart)
  chart
